import { fetchData } from "../../utils/Http"
import { serverUrl } from "../../utils/Settings"

type Request = Hotelstouch.WebApp.WebShop.Api.UpdateOrderItem.Request
type Response = Hotelstouch.WebApp.WebShop.Api.UpdateOrderItem.Response

export async function updateOrderItemApi(params: Request):Promise<Response>{
    return await fetchData<Response>(`${serverUrl}/api/publicWebShop/updateCartItem`, params)
}